import React from 'react'
import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  Spinner,
  Row,
  Col,
  Input,
  Form,
  FormGroup,
  Label
} from 'reactstrap';
import { FaArrowLeft, FaQuestionCircle } from 'react-icons/fa'

// @components
import PaginaPorDefecto from './Default'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'

// @hooks
import { useEncuesta } from 'hooks/useEncuesta'
import { useEncuestaPregunta } from 'hooks/useEncuestaPregunta'
import { useOpcionesRespuesta } from 'hooks/useOpcionRepuesta'

// @constants
import { RUTAS } from 'constants/constants';


const PrevisualizacionEncuesta = () => {
  /**
   * Hooks
   */
  const { push } = useHistory();
  const { id } = useParams();
   
  /**
    * Consultas
    */
  const {
    handleBuscarEncuestaPorId,
  } = useEncuesta()

  const {
    obtenerOpcionesRespuestas,
  } = useOpcionesRespuesta()

  const { 
    useObtenerEncuestaPreguntaPorField,
  } = useEncuestaPregunta()

  const { data: encuesta } = handleBuscarEncuestaPorId(id);
  const { data: preguntasEncuesta }
    = useObtenerEncuestaPreguntaPorField('encuesta__id', id);

  const { data: opcionesRespuesta } = obtenerOpcionesRespuestas();

  /**
   * Manjeadores
   */
   const manejadorRegresar = () => {
    push(RUTAS.ENCUESTAS);
   }
  
  const manejadorAgregarPreguntas = () => {
    push(RUTAS.DETALLE_ENCUESTA.replace(':id', id))
  }
  
  return (
    <PaginaPorDefecto
      titulo={
        <span>
          <span title="Regresar" >
            <Button className="mr-3" color="link" onClick={manejadorRegresar}>
              <FaArrowLeft />
            </Button>
          </span>
          Previsualización de encuesta {
          !encuesta && <Spinner color='primary' className="ml-3" />
        }</span>
      }
    >
      <TarjetaContenido
        titulo="Vista previa"
        component={
          <span title="Agregar preguntas">
            <Button outline color='primary' onClick={manejadorAgregarPreguntas}>
              <FaQuestionCircle />
            </Button>
          </span>
        }
        style={{ padding: '1rem' }}
      >
        {encuesta  && (
          <>
            <Row>
              <Col>
                <h1>{encuesta.titulo}</h1>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <h3>Orientada a: {encuesta.grupo_interes?.nombre}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <p style={{ textAlign: 'justify' }}>{
                  encuesta.descripcion
                  ?.replace(
                    '{OpcionesRespuesta}',
                    opcionesRespuesta?.results?.map(({ id, opcion_respuesta })=>(`${id}. ${opcion_respuesta}`)).join('\n')
                  )
                  ?.replace(
                    '{PrimeraOpcion}',
                    `(${opcionesRespuesta?.results?.[0]?.id}) "${opcionesRespuesta?.results?.[0]?.opcion_respuesta}"`
                  )
                  ?.split('\n')?.map((parrafo, index) => (
                    <span key={index}>{parrafo}<br /></span>
                  ))
                }</p>
              </Col>
            </Row>
          </>
          )
        }
        <Row>
          <Col>
            <h3>Preguntas</h3>
          </Col>
        </Row>
        <Form>
        {preguntasEncuesta?.results?.length > 0 ? (
          preguntasEncuesta?.results?.map((pregunta, index) => (
            <div key={index} className="mt-4 mb-4">
              <Row >
                <Col>
                  <h4>{index + 1}. {pregunta.preguntas__enunciado}</h4>
                </Col>
              </Row>
              {opcionesRespuesta?.results?.map((opcion, key) => (
                <FormGroup className="ml-4" check key={key}>
                  <Input
                    name={pregunta.preguntas__identificador}
                    type="radio"
                  />
                  <Label check>
                    ({opcion.id}) {opcion.opcion_respuesta}
                  </Label>
                </FormGroup>
              ))}
            </div>
          ))
        ) : (
          <Row>
            <Col>
              <h4>No hay preguntas</h4>
            </Col>
          </Row>
        )}
        </Form>
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}

export default PrevisualizacionEncuesta